import { Component, input } from '@angular/core';
import {RdsLinkModule, RdsIconsModule, RdsDividerModule } from '@rds/angular-components';
import { SafeHtmlPipe } from '../../../pipes/safe-html.pipe';

@Component({
  selector: 'inexp-knowledge-integrations',
  imports: [RdsLinkModule, RdsIconsModule, SafeHtmlPipe, RdsDividerModule],
  templateUrl: './knowledge-integrations.component.html',
  styleUrl: './knowledge-integrations.component.scss',
})
export class KnowledgeIntegrationsComponent {
  _uid = input<string>();
  component = input<string>();
  knowledgeSection = input<string>();
  integrations = input<any[]>();
  integrationLongDescription = input<string>();
  hasPublishedItems(): boolean {
    return this.integrations()?.some(b => b.published === true) ?? false;
  }
}
